import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[strongPasswordMessage]'
})
export class StrongPasswordMessageDirective {
  private tooltipElement: HTMLElement | null = null;
  private resizeListener: (() => void) | null = null;
  private scrollListener: (() => void) | null = null;

  private readonly messageList: string[] = [
    'Use a mix of lowercase and uppercase letters',
    'Password must be at least 8 characters long',
    'Spaces are not allowed',
    'Password must contain special characters'
  ];

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter')
  onMouseEnter(): void {
    if (this.tooltipElement) return;

    this.tooltipElement = this.renderer.createElement('div');
    this.renderer.setStyle(this.tooltipElement, 'position', 'absolute');
    this.renderer.setStyle(this.tooltipElement, 'background', '#f1f1f1');
    this.renderer.setStyle(this.tooltipElement, 'color', '#53535f');
    this.renderer.setStyle(this.tooltipElement, 'padding', '8px');
    this.renderer.setStyle(this.tooltipElement, 'border-radius', '4px');
    this.renderer.setStyle(this.tooltipElement, 'box-shadow', '0 2px 8px rgba(0,0,0,0.15)');
    this.renderer.setStyle(this.tooltipElement, 'font-size', '12px');
    this.renderer.setStyle(this.tooltipElement, 'z-index', '1000');
    this.renderer.setStyle(this.tooltipElement, 'max-width', '300px');
    this.renderer.setStyle(this.tooltipElement, 'word-wrap', 'break-word');

    const messageContent = this.messageList.map(msg => `<div>• ${msg}</div>`).join('');
    this.tooltipElement.innerHTML = messageContent;

    document.body.appendChild(this.tooltipElement);
    this.positionTooltip();

    this.resizeListener = this.renderer.listen('window', 'resize', () => this.positionTooltip());
    this.scrollListener = this.renderer.listen('window', 'scroll', () => this.positionTooltip());
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    if (this.tooltipElement) {
      this.tooltipElement.remove();
      this.tooltipElement = null;
    }

    this.resizeListener?.();
    this.scrollListener?.();
    this.resizeListener = null;
    this.scrollListener = null;
  }

  private positionTooltip(): void {
    if (!this.tooltipElement) return;

    const rect = this.elementRef.nativeElement.getBoundingClientRect();
    const tooltipRect = this.tooltipElement.getBoundingClientRect();
    const scrollTop = window.scrollY;
    const scrollLeft = window.scrollX;

    let top = rect.bottom + scrollTop + 4;
    let left = rect.left + scrollLeft;

    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    // Adjust if overflowing right
    if (left + tooltipRect.width > screenWidth) {
      left = screenWidth - tooltipRect.width - 10;
    }

    // Adjust if overflowing bottom
    if (top + tooltipRect.height > scrollTop + screenHeight) {
      top = rect.top + scrollTop - tooltipRect.height - 4;
    }

    this.renderer.setStyle(this.tooltipElement, 'top', `${top}px`);
    this.renderer.setStyle(this.tooltipElement, 'left', `${left}px`);
  }
}
